import { makeStyles } from "@mui/styles";
import backgroundImage from '../../assets/home.jpg'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh', // Cambiado a '100vh' para abarcar todo el alto del navegador
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  backgroundImage: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',

  },
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'rgba(71, 83, 98, 0.8)',

  },
  content: {
    flex: 1,
    display: 'flex',
  },
  lobbyTitle: {
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    color: theme.palette.primary.lightBackground,
    textTransform: 'uppercase',
  },
}));
export default useStyles;